import { render, staticRenderFns } from "./LabelPrelabelPreview.vue?vue&type=template&id=277a7a2b&scoped=true"
import script from "./LabelPrelabelPreview.vue?vue&type=script&lang=js"
export * from "./LabelPrelabelPreview.vue?vue&type=script&lang=js"
import style0 from "./LabelPrelabelPreview.vue?vue&type=style&index=0&id=277a7a2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277a7a2b",
  null
  
)

export default component.exports